import React from 'react';
import { useSelector } from 'react-redux';
import classes from './myCV.module.scss';
import { MyUploadedCV, WorkHistory, Skills, Educations, TrainingsAndCertificates } from './components';
import ProfileWrapper from './components/ProfileWrapper/ProfileWrapper';

function MyCV() {
  const profile = useSelector((state) => state.user.profile);
  const profileError = useSelector((state) => state.user.error);
  const profilePending = useSelector((state) => state.user.pendingFlag);
  const userId = localStorage.getItem('UserId');

  return (
    <ProfileWrapper profile={profile} error={profileError} pending={profilePending} userId={userId}>
      <MyUploadedCV cvName={profile?.CvName} />
      <hr className={classes.divider} />
      <WorkHistory />
      <hr className={classes.divider} />
      <Skills />
      <hr className={classes.divider} />
      <Educations />
      <hr className={classes.divider} />
      <TrainingsAndCertificates />
    </ProfileWrapper>
  );
}

export default MyCV;
